import React from 'react';

import loadingPlaceholderHTML from './LoadingPlaceholder.html?raw';

const LoadingPlaceholder = () => (
    <div
        data-testid="loading-placeholder"
        dangerouslySetInnerHTML={{ __html: loadingPlaceholderHTML }}
    />
);

export default LoadingPlaceholder;
